var _path, _g, _g2, _g3, _g4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgTaskTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 114H129.5C147 114 154 107 154 89.5V68.5C154 51 147 44 129.5 44H108.5C91 44 84 51 84 68.5V89.5C84 107 91 114 108.5 114Z",
    fill: "url(#paint0_linear_3941_58862)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3941_58862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint1_linear_3941_58862)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_3941_58862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    fill: "url(#paint2_linear_3941_58862)",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5 130H105.5C123 130 130 123 130 105.5V84.5C130 67 123 60 105.5 60H84.5C67 60 60 67 60 84.5V105.5C60 123 67 130 84.5 130Z",
    stroke: "url(#paint3_linear_3941_58862)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3941_58862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.33 76.8522C100.33 75.8293 101.16 75 102.183 75C103.206 75 104.035 75.8293 104.035 76.8522V79.6305C104.035 80.6534 103.206 81.4827 102.183 81.4827C101.16 81.4827 100.33 80.6534 100.33 79.6305V76.8522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.134 79.2469C110.857 78.5236 112.03 78.5236 112.753 79.2469C113.477 79.9702 113.477 81.143 112.753 81.8663L110.789 83.8309C110.065 84.5542 108.893 84.5542 108.169 83.8309C107.446 83.1075 107.446 81.9348 108.169 81.2114L110.134 79.2469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.169 95.9167C107.446 96.64 107.446 97.8128 108.169 98.5361L110.134 100.501C110.857 101.224 112.03 101.224 112.753 100.501C113.477 99.7773 113.477 98.6046 112.753 97.8812L110.789 95.9167C110.065 95.1934 108.893 95.1934 108.169 95.9167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4995 81.8663C90.7762 81.143 90.7762 79.9702 91.4995 79.2469C92.2229 78.5236 93.3956 78.5236 94.1189 79.2469L96.0835 81.2114C96.8068 81.9348 96.8068 83.1075 96.0835 83.8309C95.3602 84.5542 94.1874 84.5542 93.4641 83.8309L91.4995 81.8663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.148 87.9654H112.37C111.347 87.9654 110.517 88.7947 110.517 89.8176C110.517 90.8405 111.347 91.6698 112.37 91.6698H115.148C116.171 91.6698 117 90.8405 117 89.8176C117 88.7947 116.171 87.9654 115.148 87.9654Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3941_58862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2406 86.1353C98.9846 85.8936 99.786 85.8936 100.53 86.1353C101.067 86.3097 101.478 86.6052 101.801 86.8802C102.096 87.1305 102.418 87.4525 102.749 87.7831L104.198 89.2321C104.528 89.5626 104.85 89.8845 105.101 90.1794C105.376 90.5033 105.671 90.9143 105.846 91.4509C106.087 92.1949 106.087 92.9963 105.846 93.7403C105.671 94.2769 105.376 94.6879 105.101 95.0118C104.85 95.3067 104.528 95.6286 104.198 95.9591L87.005 113.152C86.6746 113.482 86.3527 113.804 86.0578 114.055C85.7339 114.33 85.3229 114.625 84.7863 114.8C84.0423 115.041 83.2409 115.041 82.4969 114.8C81.9603 114.625 81.5493 114.33 81.2254 114.055C80.9305 113.804 80.6086 113.482 80.2781 113.152L78.8291 111.703C78.4985 111.372 78.1765 111.05 77.9261 110.755C77.6512 110.432 77.3557 110.021 77.1813 109.484C76.9396 108.74 76.9396 107.939 77.1813 107.195C77.3557 106.658 77.6512 106.247 77.9261 105.923C78.1765 105.628 78.4984 105.306 78.829 104.976L96.0218 87.7831C96.3523 87.4525 96.6742 87.1305 96.9691 86.8802C97.293 86.6052 97.7039 86.3097 98.2406 86.1353ZM98.1618 96.019C97.9502 95.9503 97.7666 95.7667 97.3995 95.3996L96.5813 94.5814C96.2141 94.2143 96.0306 94.0307 95.9619 93.8191C95.9015 93.6329 95.9016 93.4324 95.9622 93.2463C96.0312 93.0348 96.2149 92.8514 96.5825 92.4847L98.3375 90.7337C98.7043 90.3678 98.8877 90.1848 99.0991 90.1163C99.285 90.0561 99.4852 90.0562 99.671 90.1167C99.8823 90.1854 100.065 90.3686 100.432 90.7349L101.246 91.5491C101.612 91.9154 101.795 92.0986 101.864 92.3099C101.925 92.4957 101.925 92.6959 101.865 92.8818C101.796 93.0932 101.613 93.2766 101.247 93.6434L99.4962 95.3984C99.1295 95.766 98.9461 95.9497 98.7346 96.0187C98.5485 96.0793 98.348 96.0794 98.1618 96.019Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3941_58862",
    x: 0,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "effect1_foregroundBlur_3941_58862"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_3941_58862",
    x: 43.25,
    y: 43.25,
    width: 103.5,
    height: 103.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3941_58862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3941_58862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3941_58862",
    x: 90.957,
    y: 75,
    width: 26.043,
    height: 28.0432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3941_58862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3941_58862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3941_58862",
    x: 77,
    y: 85.954,
    width: 29.0273,
    height: 31.0269,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3941_58862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3941_58862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3941_58862",
    x1: 89,
    y1: 51,
    x2: 142,
    y2: 119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3941_58862",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3941_58862",
    x1: 65,
    y1: 67,
    x2: 118,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52E8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B47FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3941_58862",
    x1: 123,
    y1: 66,
    x2: 66,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0285714,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgTaskTemplates);
export default __webpack_public_path__ + "static/media/ImgTaskTemplates.701f7a54e3b5e32837833c8e51c3542b.svg";
export { ForwardRef as ReactComponent };